import { render } from "./homepage.vue?vue&type=template&id=297436fe&scoped=true"
import script from "./homepage.vue?vue&type=script&lang=js"
export * from "./homepage.vue?vue&type=script&lang=js"

import "./homepage.vue?vue&type=style&index=0&id=297436fe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-297436fe"]])

export default __exports__